// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"q3-z","displaySixCardTiles":"r3-z"};